export class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}
//# sourceMappingURL=Feature.js.map